import { useContext, useEffect, useState } from "react";
import Header from "../Layout/Header";
import Sidebar from "../Layout/Sidebar";
import ChecklistItem from "../components/ChecklistItem";
import prepChecklistArrowIcon1 from '../assets/images/siteImg/prep-checklist-icon-collapse.svg';
import bannerImage from '../assets/images/banners/bannerImage_checklist.png';
import markReadImage from '../assets/images/siteImg/imagemarkread.png';
import iconInfo from '../assets/images/icon_info.svg';
import config from "../config";
import { useChecklist } from "../context/ChecklistContext";
import { Footer } from "../Layout/Footer";
import { FooterMobile } from "../Layout/FooterMobile";
import { calculateCompletionPercentage, filterChecklistsByRole, formatCategoryName, getChecklistStatus, categoryIcons, calculateChecklistCompletion } from "../utils/checklistUtils";
import { useOverviewContext } from "../context/OverviewContext";
import HeroBanner from "../components/HeroBanner";
import { Breadcrumb } from "react-bootstrap";
import Breadcrumbs from "../components/Breadcrumb";

export function SchoolPrepChecklist() {
const { HOME, FORM_DOCS_MAIN_CHECKLIST, LEARNING_COACH_OVERVIEW_URL, LEARNING_COACH_ROLE_URL,SCHOOL_START_FAQ, NAVIGATE_OS, SAMPLE_LESSONS, EMAIL_BASICS, EMAIL_OPTIONS } = config.app.routes;

const { userRoleVal, hasNonHighSchoolStudents } = useOverviewContext();
const { checklistData, checklistTopicStatus } = useChecklist();
// get data as per role
const checklistCategoryData = filterChecklistsByRole(
  checklistData, 
  checklistTopicStatus, 
  userRoleVal, 
  FORM_DOCS_MAIN_CHECKLIST,
  hasNonHighSchoolStudents
);
const categoryMappings: { [key: string]: { title: string; description: string; toggleId: number } } = {
  FORMS_AND_DOCUMENTS: {
    title: "Forms and Documents", //Fallback title but data rendering from API
    description: "Get all the details in place!",
    toggleId: 14,
  },
  LEARNING_COACH_LIFE: {
    title: "Learning Coach Life",
    description: "Shape your student's future!",
    toggleId: 9,
  },
  ONLINE_SCHOOL: {
    title: "Online School",
    description: "Learn how to navigate your online school.",
    toggleId: 3,
  },
  SCHOOL_EMAIL: {
    title: "School Email",
    description: "Let's connect!",
    toggleId: 11,
  },
};

const checkListValues = Array.from(checklistCategoryData.entries()).map(([category, topics]) => {
  const formattedCategoryKey = category.toLowerCase().replace(/_/g, "-");
  // Extract completed checklist IDs from checklistTopicStatus percentageLogic
  const completedChecklistIds = checklistTopicStatus
    .filter(item => item.status === "true")
    .map(item => item.checklistId);
  const calc_percentage = calculateChecklistCompletion(checklistData, category, completedChecklistIds, hasNonHighSchoolStudents);
//   console.log(calc_percentage);

  return { 
    title: formatCategoryName(category) || categoryMappings[category]?.title, 
    description: categoryMappings[category]?.description || "",
    percentage: calc_percentage,
    imageUrl: categoryIcons[formattedCategoryKey] || "", 
    topics: topics
    .filter((topic: { checklistNameFormat: string }) =>
        hasNonHighSchoolStudents || topic.checklistNameFormat !== "CONSENT_PROCESS"
    )
    .map((topic: { title: string; linkUrl: string; checklistId: string; checklistNameFormat:string }) => ({
      title: topic.title,
      link: topic.linkUrl,
      completed: completedChecklistIds.includes(topic.checklistId),
      checklistNameFormat: topic.checklistNameFormat
    })),
    toggleId: categoryMappings[category]?.toggleId || 0,
    icon: prepChecklistArrowIcon1, 
  };
});

// console.log(hasNonHighSchoolStudents, "checkListValues: " ,checkListValues);

const [expandedId, setExpandedId] = useState<number | null>(null);
const toggleVisibility = (id: number) => {
    setExpandedId(expandedId === id ? null : id);
};
const breadcrumbItems = [
    { label: "Home", path: "/" },
    { label: "School Prep Checklist", path: "/school-prep-checklist" },
];
return (
<>
    
    <div className="home-layout">
        <div className="sidebar-wrapper">
        <Sidebar />
        </div>
        <div className="body-wrapper-content">
        <div className="row">
            <div className="col-12">
            <Header />
            <main id="main" role="main">
            <div className="main-content" id="school-prep-checklist">
                <div className="row">
                    <div className="col-12">
                        <Breadcrumbs items={breadcrumbItems} />
                    </div>
                </div>

                <HeroBanner
                    title="School Prep Checklist"
                    subtitle="Here's the info you need to be prepared for K12-powered online school."
                    imageUrl={bannerImage}
                    altText="School Prep Checklist"
                    customClass="bg-color-blue-t1-checklist common-banner-bg-white"
                />

                <div className="wp-block-k12-section container-fluid bg-transparent container">
                    <div className="row">
                    <div className="col-12 g-0">
                        <div className="wp-block-columns is-layout-flex wp-container-core-columns-is-layout-1 wp-block-columns-is-layout-flex">
                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: '66.66%' }}>
                            <div className="wp-block-k12-checklist-category-grid container-fluid p-0">
                            <div className="row">
                                <div className="col-12">
                                <ul>
                                    {checkListValues.map((item, index) => (
                                        <ChecklistItem 
                                        key={index}
                                        title={item.title}
                                        description={item.description}
                                        percentage={item.percentage}
                                        imageUrl={item.imageUrl}
                                        topics={item.topics}
                                        toggleId={item.toggleId}
                                        icon={item.icon}
                                        />
                                    ))}
                                </ul>
                                </div>
                            </div>
                            </div>
                        </div>
                        <div className="wp-block-column is-layout-flow wp-block-column-is-layout-flow" style={{ flexBasis: '33.33%' }}>
                            <div className="wp-block-k12-section container-fluid bg-color-blue-t1-checklist p-3rem">
                            <div className="row">
                                <div className="col-12 g-0">
                                <figure className="wp-block-image size-large is-resized mb-4">
                                    <img
                                    loading="lazy"
                                    decoding="async"
                                    width="24"
                                    height="24"
                                    src={iconInfo}
                                    alt=""
                                    className="wp-image"
                                    style={{ width: '24px' }}
                                    />
                                </figure>
                                <h3 className="wp-block-heading">Track Your Progress</h3>
                                <p className="mb-2">
                                    <strong>Show how much you know!</strong>
                                </p>
                                <p>
                                    As you go through and read each topic, click the button at the bottom of the page to indicate you have finished
                                    before moving on. 
                                </p>
                                <figure className="wp-block-image size-full m-0">
                                    <img
                                    loading="lazy"
                                    width="760"
                                    height="160"
                                    src={markReadImage}
                                    alt=""
                                    className="wp-image"
                                    sizes="auto, (max-width: 760px) 100vw, 760px"
                                    />
                                </figure>
                                </div>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>

            </div>

            </main>
            </div>
        </div>

        </div>
        <FooterMobile />
    </div>
</>   
);
}